import { useEffect, useState } from 'react';
import {useLocation } from "react-router-dom";

// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
// import Lenis from 'lenis'

function Header() {

    const location = useLocation();
  const currentPath = location.pathname;

    const [scrolled, setScrolled] = useState(false);
    const [isShow, setIsShow] = useState(false);

  const showMenu = () => {
    setIsShow(!isShow);
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    

    window.addEventListener('scroll', handleScroll);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
    return (
       <header>
        
                

                    {/* <!--Start mainmenu area--> */}
                    <section className={`mainmenu-area stricky ${scrolled ? 'stricky-fixed' : ''}`}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-12 col-sm-12 col-xs-12">
                                    {/* <!--Start mainmenu--> */}
                                    <nav className="main-menu">
                                           <div className="logo disable-desktop brand-logo">
                                                <a  href="/">
                                                    <img src="assets/images/resources/logo.png" alt="Awesome Logo"/>
                                                </a>
                                            </div>
                                        <div className="navbar-header" onClick={showMenu}>   	
                                            <button type="button" className="navbar-toggle" data-toggle="collapsed" data-target=".navbar-collapse">
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                                <span className="icon-bar"></span>
                                            </button>
                                        </div>
                                        <div className={`navbar-collapse clearfix ${isShow ? 'show' : ''}`} id="basic-navbar-nav">
                                        
                                            <ul className="navigation clearfix">
                                          <li className="logo disable-mobile">
                                                <a  href="/">
                                                    <img src="assets/images/resources/logo.png" alt="Awesome Logo"/>
                                                </a>
                                            </li>
                                                <li><a href="/" className={currentPath === "/" ? "current" : ""}>Home</a></li>
                                                <li><a href="/about-indusref" className={currentPath === "/about-indusref" ? "current" : ""}>About Us</a></li>
                                                <li className="dropdown"><a href="/industrial-refrigeration" className={currentPath === "/industrial-refrigeration" ? "current" : ""}>Products</a>
                                                    <ul>
                                                        <li><a href="/industrial-refrigeration">Skid Mounted Refpacks</a></li>
                                                        <li><a href="/cooling-and-chilling">Cooling & Chilling Systems</a></li>
                                                        <li><a href="/heat-pumps">Heat Pumps</a></li>
                                                         <li><a href="/ICE-production-systems">ICE Production Systems</a></li>
                                                        <li><a href="/ammonia-recirculator-package">Ammonia Recirculator Package</a></li>
                                                        <li><a href="/cooling-condenser">Cooling Condenser</a></li>
                                                        <li><a href="/freezers">Freezers</a></li>
                                                        <li><a href="/pressure-vessels">Pressure Vessels</a></li>
                                                          <li><a href="/control-systems">Control Systems</a></li>
                                                        <li><a href="/support-services">Support Services</a></li>
                                                    </ul>
                                                </li>
                                                {/* <li><a href="/reviews">Reviews</a></li> */}
                                               <li className="dropdown">
                                                <a href="/indusref-markets" className={currentPath === "/indusref-markets" ? "current" : ""}>Markets</a>
                                                  <ul>
                                                        <li><a href="/market-food">Food</a></li>
                                                        <li><a href="/market-dairy">Dairy</a></li>
                                                        <li><a href="/market-HVAC">Industrial HVAC</a></li>
                                                        <li><a href="/market-beverage">Beverage</a></li>
                                                        <li><a href="/market-pharma">Pharma</a></li>
                                                        <li><a href="/market-oil-gas-chemical">Oil / Gas / Chemical / Power </a></li>
                                                        <li><a href="/market-Cold-Storage-and-WareHouse">Cold Storage & WareHouse</a></li>
                                                        {/* <li><a href="/market-General-Industries">General Industries</a></li> */}
                                                   </ul>
                                                </li>
                                                {/* <li className="dropdown">
                                                    <a href="/indusref-markets">Markets</a>
                                                    <ul>
                                                        <li><a href="/specials-rebate-v1">Specials & Rebate One</a></li>
                                                        <li><a href="/specials-rebate-v2">Specials & Rebate Two</a></li>
                                                    </ul>
                                                </li> */}
                                                <li><a href="/indusref-partners" className={currentPath === "/indusref-partners" ? "current" : ""}>Partners</a>
                                                
                                                 
                                                </li>

                                                 {/* <li><a href="/indusref-clients" className={currentPath === "/indusref-clients" ? "current" : ""}>Clients</a></li> */}
                                                 <li><a href="/contact" className={currentPath === "/contact" ? "current" : ""}>Contact</a></li>
                                                {/* <li className="dropdown"><a href="/blog-grid">Blog</a>
                                                    <ul>
                                                        <li><a href="/blog-grid">Blog Grid View</a></li>
                                                        <li><a href="/blog">Blog With Sidebar</a></li>
                                                        <li><a href="/blog-single">Blog Single Post</a></li>
                                                    </ul>
                                                </li> */}
                                                {/* <li><a href="/contact" className={currentPath === "/contact" ? "current" : ""}>Contact Us</a></li> */}
                                            </ul>
                                        </div>
                                    </nav>
                                    {/* <!--End mainmenu--> */}
                                    <div className="appoinment-button">
                                        <a href="/contact">Make an Appoinment</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    {/* <!--End mainmenu area-->         */}

       </header>
    )
}

export default Header;